'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  margin-bottom: ', ';\n  border-bottom: ', ' solid ', ';\n'], ['\n  position: relative;\n  margin-bottom: ', ';\n  border-bottom: ', ' solid ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: none;\n  ', ';\n'], ['\n  display: none;\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    flex-basis: 0;\n    margin: 0;\n    padding: 0;\n    background-color: transparent;\n    position: relative;\n    text-align: left;\n  '], ['\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    flex-basis: 0;\n    margin: 0;\n    padding: 0;\n    background-color: transparent;\n    position: relative;\n    text-align: left;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: none;\n  position: absolute;\n  padding: ', ';\n  background-color: ', ';\n  min-width: ', ';\n  z-index: 10;\n  li {\n    margin-left: 0;\n    + li {\n      margin-top: ', ';\n    }\n    a {\n      padding: 0;\n      color: ', ';\n      &:before {\n        display: none;\n      }\n    }\n  }\n'], ['\n  display: none;\n  position: absolute;\n  padding: ', ';\n  background-color: ', ';\n  min-width: ', ';\n  z-index: 10;\n  li {\n    margin-left: 0;\n    + li {\n      margin-top: ', ';\n    }\n    a {\n      padding: 0;\n      color: ', ';\n      &:before {\n        display: none;\n      }\n    }\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  margin-left: ', ';\n  svg path {\n    transition: fill 0.3s ease;\n    fill: ', ';\n  }\n'], ['\n  margin-left: ', ';\n  svg path {\n    transition: fill 0.3s ease;\n    fill: ', ';\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: relative;\n'], ['\n  display: inline-block;\n  position: relative;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: ', ' ', ';\n  transition: color 0.3s ease;\n  color: ', ';\n  position: relative;\n  overflow: hidden;\n  &:before {\n    content: \' \';\n    height: ', ';\n    width: 100%;\n    bottom: ', ';\n    left: 0;\n    background-color: ', ';\n    position: absolute;\n    transition: bottom 0.3s ease;\n  }\n'], ['\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: ', ' ', ';\n  transition: color 0.3s ease;\n  color: ', ';\n  position: relative;\n  overflow: hidden;\n  &:before {\n    content: \' \';\n    height: ', ';\n    width: 100%;\n    bottom: ', ';\n    left: 0;\n    background-color: ', ';\n    position: absolute;\n    transition: bottom 0.3s ease;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  list-style-type: none;\n  position: relative;\n  margin-left: ', ';\n  &:first-child {\n    margin-left: 0;\n  }\n  &:hover {\n    > a {\n      color: ', ';\n      &:before {\n        bottom: ', ';\n      }\n    }\n    ', ' {\n      svg path {\n        fill: ', ';\n      }\n    }\n    ', ' {\n      display: block;\n    }\n  }\n'], ['\n  list-style-type: none;\n  position: relative;\n  margin-left: ', ';\n  &:first-child {\n    margin-left: 0;\n  }\n  &:hover {\n    > a {\n      color: ', ';\n      &:before {\n        bottom: ', ';\n      }\n    }\n    ', ' {\n      svg path {\n        fill: ', ';\n      }\n    }\n    ', ' {\n      display: block;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _polished = require('polished');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.nav(_templateObject, (0, _polished.rem)(20), (0, _polished.rem)(1), function (_ref) {
  var theme = _ref.theme;
  return theme.actionMenu.borderColor;
});

var ListWrapper = _styledComponents2.default.ul(_templateObject2, function (_ref2) {
  var theme = _ref2.theme;
  return theme.media.m(_templateObject3);
});

var SubListWrapper = (0, _styledComponents2.default)(ListWrapper)(_templateObject4, (0, _polished.rem)(20), function (_ref3) {
  var theme = _ref3.theme;
  return (0, _polished.rgba)(theme.color.gray, 0.9);
}, (0, _polished.rem)(170), (0, _polished.rem)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.white;
});

var ArrowIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject5, (0, _polished.rem)(10), function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.textColor;
});

var TextWrapper = _styledComponents2.default.div(_templateObject6);

var ActionLink = _styledComponents2.default.a(_templateObject7, (0, _polished.rem)(10), (0, _polished.rem)(15), function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.textColor;
}, (0, _polished.rem)(3), (0, _polished.rem)(-3), function (_ref7) {
  var theme = _ref7.theme;
  return theme.color.primary;
});

var List = _styledComponents2.default.li(_templateObject8, (0, _polished.rem)(15), function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.primary;
}, (0, _polished.rem)(-1), ArrowIcon, function (_ref9) {
  var theme = _ref9.theme;
  return theme.color.primary;
}, SubListWrapper);

var ActionMenu = function (_PureComponent) {
  _inherits(ActionMenu, _PureComponent);

  function ActionMenu() {
    var _ref10;

    var _temp, _this, _ret;

    _classCallCheck(this, ActionMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref10 = ActionMenu.__proto__ || Object.getPrototypeOf(ActionMenu)).call.apply(_ref10, [this].concat(args))), _this), _this.itemRenderer = function (section, level) {
      return _react2.default.createElement(
        List,
        { key: section._id },
        _react2.default.createElement(
          ActionLink,
          null,
          _react2.default.createElement(
            TextWrapper,
            { onClick: function onClick() {
                return _this.props.onClickLink(section);
              } },
            section.name
          ),
          section.sections && section.sections.length > 0 && _react2.default.createElement(ArrowIcon, { size: 's', name: 'chevron' })
        ),
        section.sections && section.sections.length > 0 && _react2.default.createElement(
          SubListWrapper,
          null,
          section.sections.map(function (item) {
            return _this.itemRenderer(item, level + 1);
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActionMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sections = this.props.sections;

      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          ListWrapper,
          null,
          sections.map(function (item) {
            return _this2.itemRenderer(item, 1);
          })
        )
      );
    }
  }]);

  return ActionMenu;
}(_react.PureComponent);

ActionMenu.propTypes = {
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    id: _propTypes2.default.string,
    url: _propTypes2.default.string
  }).isRequired).isRequired,
  onClickLink: _propTypes2.default.func.isRequired
};

exports.default = ActionMenu;
ActionMenu.__docgenInfo = [{
  'description': '',
  'displayName': 'ActionMenu',
  'methods': [{
    'name': 'itemRenderer',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'section',
      'type': null
    }, {
      'name': 'level',
      'type': null
    }],
    'returns': null
  }],
  'props': {
    'sections': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'shape',
          'value': {
            'name': {
              'name': 'string',
              'required': false
            },
            'id': {
              'name': 'string',
              'required': false
            },
            'url': {
              'name': 'string',
              'required': false
            }
          }
        }
      },
      'required': true,
      'description': ''
    },
    'onClickLink': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/ActionMenu/index.js'] = {
    name: 'ActionMenu',
    docgenInfo: ActionMenu.__docgenInfo,
    path: 'src/ActionMenu/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/ActionMenu/index.js
// module id = 294
// module chunks = 1